// 设备管理
import type { Device, DeviceVo } from "../../../../common/types/device";
import { BaseService } from "@/api/baseService";
import httpRequest from "@/api/index";
import { VideoPlayerUrl } from "@/api/legacy";

export class DeviceService extends BaseService<Device, DeviceVo, any, any> {
    // 获取抓拍照片
    public async getCapture(serialNo: string): Promise<string> {
        const { data } = await this.service.get(`${this.path}/capture`, {
            params: { deviceSerial: serialNo }
        });
        return data;
    }

    // 海康云眸取流认证token获取
    public async accountInfo(): Promise<{ appKey: string; token: string }> {
        const { data } = await this.service.get(`${this.path}/account/info`);
        return data;
    }
    public async videoPlay(deviceSerial: string, mode: string, dateRange: string = ""): Promise<string> {
        enum Source {
            CUSTOM = "2"
        }
        const { token } = await this.accountInfo();
        return VideoPlayerUrl.replace("{dateRange}", dateRange)
            .replace("{token}", token)
            .replace("{deviceSerial}", deviceSerial)
            .replace("{mode}", mode)
            .replace("{origin}", Source.CUSTOM);
    }
}
export const deviceService = new DeviceService("/device", httpRequest);
